import { Typography } from "cwb-react";
import styled from "styled-components";

export const InputLabel = styled(Typography)`
  font-size: ${(p) => p.theme.input.label.fontSize};
  font-weight: ${(p) => p.theme.input.label.fontWeight};
  line-height: ${(p) => p.theme.input.label.lineHeight};
`;
